module.exports = __webpack_public_path__ + "media/images/emails-and-contacts-3-8daabc4423a6aaef85b676122a714534.svg";